const Playing = (props) => (
  <svg
    fill="none"
    viewBox="0 0 24 25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="currentColor">
      <rect
        height="4.20977"
        rx="1.02528"
        width="2.05057"
        x="5.11523"
        y="10.0954"
        className="bar bar-1"
      />
      <rect
        height="6.85281"
        rx="1.02528"
        width="2.05057"
        x="8.04395"
        y="8.77372"
        className="bar bar-2"
      />
      <rect
        height="12.9223"
        rx="1.02528"
        width="2.05057"
        x="10.9736"
        y="5.739"
        className="bar bar-3"
      />
      <rect
        height="9.46726"
        rx="1.02528"
        width="2.05057"
        x="13.9033"
        y="7.46649"
        className="bar bar-4"
      />
      <rect
        height="4.20977"
        rx="1.02528"
        width="2.05057"
        x="16.833"
        y="10.0954"
        className="bar bar-5"
      />
    </g>
  </svg>
);
export default Playing;
